import axios from 'axios';
import React, {useEffect, useState, useRef } from 'react';
import '../../styles/global.css'; // Seu CSS global
import { useParams, useNavigate } from 'react-router-dom';
import { WhatsApp, Mail, MailOutline } from '@mui/icons-material';
import Tooltip from '@mui/material/Tooltip';

function Assembleia() {
    const { idAssembleia } = useParams();
    const navigate = useNavigate();
    const loggedIn = sessionStorage.getItem('loggedIn');
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [assembleiaInfo, setAssembleiaInfo] = useState([]);
    const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
    const now = new Date();
    const customFormatDate = new Intl.DateTimeFormat('pt-BR', {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false
    }).format(now).replace(/\//g, '/').replace(',',''); // Replace slashes with hyphens
    const uuid = customFormatDate.replace('-', '').replace(' ', '').replace(':', '').replace(':', '').replace('/', '').replace('/', '');    
    //objeto principal
    const [assembleia, setAssembleia] = useState({
        IdAssembleia: idAssembleia !== undefined && parseInt(idAssembleia) ? parseInt(idAssembleia) : 0,
        assDescricao: '',
        assTipo: 'ORDINÁRIA',
        assFormato: 'VIRTUAL',
        assConvocacao: '',
        assPrimeiraConvocacao: '',
        assSegundaConvocacao: '',
        assLocalPresencial: '',
        assLinkDeAcesso: '',
        assPosicao: 'CONVOCADO',
        assConvocados: '',
        assPresentes: '',
        assAta: '',
        assAnexo: '',
        assEnviarComunicacao: 0,
        assStatus: 1,
        assCriadoPor: sessionStorage.nomeUsuario ? sessionStorage.nomeUsuario : 'Usuário Desconecido',
        assCriadoEm: customFormatDate,
        assAlteradoPor: sessionStorage.nomeUsuario ? sessionStorage.nomeUsuario : 'Usuário Desconecido',
        assAlteradoEm: customFormatDate,
        assCodigoGUID: uuid + '-'+ Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
    });
    // auto-resize textarea for assembleia description
    // const textareaRef = useRef(null);
    // auto-resize handler for textarea
    // const handleInput = (e) => {
    //     const textarea = textareaRef.current;
    //     textarea.style.height = 'auto'; // Reseta a altura para recalcular
    //     textarea.style.height = `${textarea.scrollHeight}px`; // Define com base no conteúdo
    // };
    //volta para a página anterior
    function handleFecharModal() {
        window.history.back();
    }
    //envia para login se o usuário não estiver logado
    useEffect(() => {
        if (loggedIn === false || loggedIn === null || loggedIn === undefined)
        {
            navigate('/Login');
            window.location.reload();
        }
    }, []);

    //console.log(idAssembleia);
    //carrega dados da assembleia se idAssembleia for diferente de 0
    useEffect(() => {
        if (idAssembleia !== undefined && parseInt(idAssembleia) > 0) {
            setIsLoading(true);
            //console.log(idAssembleia);
            const dados = {
                IdAssembleia: idAssembleia
            }
            axios
            .post(
                process.env.REACT_APP_API_URL +
                `/routes.php?metodo=obterAssembleias`,
                JSON.stringify(dados),
                { headers: { 
                    "X-Access-Token": tokenAPI,
                    "Content-Type": "application/json; charset=UTF-8"
                } }
            )
            .then(response => {
                if(response.data) {
                    setAssembleia(response.data[0]);
                    setIsLoading(false);
                } else {
                    console.log('Assembleia não encontrada. Por favor, verifique o ID da assembleia e tente novamente.');
                    setIsLoading(false);
                    navigate('/Assembleias');
                }
                
            })
            .catch(error => {
                let ret = error.message;
                console.log('Erro ao buscar informações da assembleia:', error);
                alert('Ocorreu um erro ao carregar as informações da assembleia. Por favor, tente novamente mais tarde.');
                setIsLoading(false);
                if (ret.includes("401")) {
                    console.log("token inválido!")
                }
            });
        }
    }, [idAssembleia]);
    //pessoas convocadas e pessoas presentes
    const [pessoas, setPessoas] = useState([]);
    const [pessoasConvocadas, setPessoasConvocadas] = useState([]);
    const [pessoasPresentes, setPessoasPresentes] = useState([]);
    //carrega pessoas
    useEffect(() => {
        setIsLoading(true);
        axios
        .get(
        process.env.REACT_APP_API_URL +
        '/routes.php?metodo=obterAssociadosAtivos',
        { headers: { 
            "X-Access-Token": tokenAPI,
            "Content-Type": "application/json; charset=UTF-8"
        } }
        )
        .then(response => {
        setPessoas(response.data)
        setIsLoading(false);
        })
        .catch(error => {
        let ret = error.message;
        setIsLoading(false);
        if (ret.includes("401")) {
            console.log("token inválido!")
        }
        })
    }, []);
    // Determina se TODAS as pessoas estão selecionadas atualmente
    const todasSelecionadas = pessoasConvocadas.length === pessoas.length;
    // Função para selecionar ou deselecionar todo mundo
    const toggleSelecionarTodos = () => {
        if (pessoasConvocadas.length === pessoas.length) {
        // Se todas já estavam selecionadas, esvazia o estado
            setPessoasConvocadas([]);
            setPessoasPresentes([]);
        } else {
        // Se não, coloca todas as pessoas da lista no estado
            setPessoasConvocadas([...pessoas]);
            setPessoasPresentes([...pessoasConvocadas]);
        }
    };
    // Seleciona ou deseleciona uma pessoa específica
    const toggleConvocaPessoa = (pessoa) => {
        setPessoasConvocadas(prevState => {
            const estaConvocado = prevState.some((p) => p.IdPessoa === pessoa.IdPessoa);
            if (estaConvocado) {
                return prevState.filter((p) => p.IdPessoa !== pessoa.IdPessoa);
            } else {
                return [...prevState, pessoa];
            }
        });
    };
    // a propriedade assConvocados tem separado por ; os IdPessoas convocadas salvos na base, e deve ser usada para inicializar o estado pessoasConvocadas quando o componente for montado.
    useEffect(() => {
        if (assembleia && assembleia.assConvocados) {
            const convocados = assembleia.assConvocados.split(';').map(id => id.trim());
            const pessoasConvocadasInicial = pessoas.filter(pessoa => convocados.includes(pessoa.IdPessoa.toString()));
            setPessoasConvocadas(pessoasConvocadasInicial);
        }
    }, [assembleia, pessoas]);

    // Deetermina se TODAS as pessoas estavam presentes
    const todasPresentes = pessoasPresentes.length === pessoasConvocadas.length;
    // função que marca presença de todos ou nenhuma presença
    const toggleMarcarTodosPresentes = () => {
        if (pessoasPresentes.length === pessoasConvocadas.length) {
            setPessoasPresentes([]);
        } else {
            setPessoasPresentes([...pessoasConvocadas]);
        }
    };
    // Marca ou desmarca a presença de uma pessoa específica
    const togglePresencaPessoa = (pessoa) => {
        setPessoasPresentes(prevState => {
            const estaPresente = prevState.some((p) => p.IdPessoa === pessoa.IdPessoa);
            if (estaPresente) {
                return prevState.filter((p) => p.IdPessoa !== pessoa.IdPessoa);
            } else {
                return [...prevState, pessoa];
            }
        });
    };
    // a propriedade assPresentes tem separado por ; os IdPessoas presentes salvos na base, e deve ser usada para inicializar o estado pessoasPresentes quando o componente for montado.
    useEffect(() => {
        if (assembleia && assembleia.assPresentes) {
            const presentes = assembleia.assPresentes.split(';').map(id => id.trim());
            const pessoasPresentesInicial = pessoasConvocadas.filter(pessoa => presentes.includes(pessoa.IdPessoa.toString()));
            setPessoasPresentes(pessoasPresentesInicial);
        }
    }, [assembleia, pessoasConvocadas]);

    //console.log(pessoasConvocadas);
    const [bloqueio, setBloqueio] = useState(false);
    const [file, setFile] = useState(null);
    const [uploadStatus, setUploadStatus] = useState('');
    const [PdfFile, setPdfFile] = useState({
                NomePdf: '',
                Arquivo: ''
            });
    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };

    //recebe o nome e formata, devolve em string
    const formatarNome = (nome) => {
        let nomeFormatado = '';
            const arrayNome = nome.trim().split(' ');
            if (arrayNome.length < 3) {
                nomeFormatado = nome; 
            } else {
                nomeFormatado = arrayNome[0];
                
                for (let i = 1; i < arrayNome.length - 1; i++) {
                    if (arrayNome[i].length > 2 
                        && i < arrayNome.length
                        && arrayNome[i].toUpperCase().trim() !== 'DOS'
                        && arrayNome[i].toUpperCase().trim() !== 'DA'
                        && arrayNome[i].toUpperCase().trim() !== 'DE'
                        && arrayNome[i].toUpperCase().trim() !== 'DO'
                        && arrayNome[i].toUpperCase().trim() !== 'DAS'
                        && arrayNome[i].toUpperCase().trim() !== 'DOS') {
                        nomeFormatado += ' ' + arrayNome[i].charAt(0) + '.';
                    } else {
                        nomeFormatado += ' ' + arrayNome[i];
                    }
                }
                nomeFormatado += ' ' + arrayNome[arrayNome.length - 1];
            }
        return nomeFormatado;
    };

    function handleSalvarAssembleia(event) {
        event.preventDefault();
        // lógica para salvar a assembleia
        //valida campo descricao
        if (!assembleia.assDescricao || assembleia.assDescricao.trim() === '') {
            alert('O campo descrição é obrigatório.');
            return;
        }
        //valida campo convocação que precisa ser data valida, apesar de salvar como string
        if (!assembleia.assConvocacao || isNaN(Date.parse(assembleia.assConvocacao))) {
            alert('O campo convocação deve ser uma data válida.');
            return;
        }
        //valida campo primeira e segunda convocação que precisam ser horas válidas apesar de salvar como string
        if (!assembleia.assPrimeiraConvocacao || !/^([01]\d|2[0-3]):([0-5]\d)$/.test(assembleia.assPrimeiraConvocacao)) {
            alert('O campo primeira convocação deve ser uma hora válida (HH:mm).');
            return;
        }
        if (!assembleia.assSegundaConvocacao || !/^([01]\d|2[0-3]):([0-5]\d)$/.test(assembleia.assSegundaConvocacao)) {
            alert('O campo segunda convocação deve ser uma hora válida (HH:mm).');
            return;
        }
        // Validação para não permitir encerrar uma assembleia que ainda não foi criada
        if (assembleia.assPosicao && assembleia.assPosicao.toLowerCase() === "encerrado" && parseInt(assembleia.IdAssembleia) === 0) {
            alert('Não é possível encerrar uma assembleia que ainda não foi criada.');
            return;
        }
        // Validação para não permitir cancelar uma assembleia que ainda não foi criada
        if (assembleia.assPosicao && assembleia.assPosicao.toLowerCase() === "cancelado" && parseInt(assembleia.IdAssembleia) === 0) {
            alert('Não é possível cancelar uma assembleia que ainda não foi criada.');
            return;
        }

        // Atualiza os campos assConvocados e assPresentes da assembleia com base nos estados locais
        // convocados
        if (pessoasConvocadas.length > 0) {
            // passar por cada registro de pessoasConvocadas e criar uma string
            const convocadosString = pessoasConvocadas.map(p => p.IdPessoa).join(';');
            // atualizar o assembleia.assConvocados com a string gerada
            assembleia.assConvocados = convocadosString;
        } else {
            assembleia.assConvocados = '';
        }
        //presentes
        if (pessoasPresentes.length > 0) {
            // passar por cada registro de pessoasPresentes e criar uma string com os IdPessoa separado por ;
            const presentesString = pessoasPresentes.map(p => p.IdPessoa).join(';');
            // atualizar o assembleia.assPresentes com a string gerada
            assembleia.assPresentes = presentesString;
        } else {
            assembleia.assPresentes = '';
        }
        // Validação dos dados antes de enviar para o backend
        // enviar comunicação somente se houver pessoas convocadas
        if (parseInt(assembleia.assEnviarComunicacao) === 1 && pessoasConvocadas.length === 0) {
            alert('Não é possível enviar comunicação sem pessoas convocadas.');
            return;
        }
        // encerramento da assembleia somente se houver pessoas presentes
        if (assembleia.assPosicao.toLowerCase() === "encerrado" && pessoasPresentes.length === 0) {
            alert('Não é possível encerrar uma assembleia sem pessoas presentes.');
            return;
        }
        // alerta quando a assembleia é cancelada com pessoas presentes
        if (assembleia.assPosicao.toLowerCase() === "cancelada" && pessoasPresentes.length > 0) {
            alert('Não é possível cancelar uma assembleia com pessoas presentes.');
            return;
        }
        //alerta de encerramento de assembleia sem a ata
        if (assembleia.assPosicao.toLowerCase() === "encerrado" && (!assembleia.assAta || assembleia.assAta.trim() === '') || assembleia.assAta === undefined) {
            alert('Não é possível encerrar a assembleia sem a ata.');
            return;
        }

        //verifica se foi selecionado arquivo de anexo e faz o upload e salva o caminho em assAnexo
        if (file) {
            const formData = new FormData();
            formData.append('file', file);
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function (fileLoadedEvent) {
                var srcData = fileLoadedEvent.target.result;
                PdfFile['Arquivo'] = srcData.split(',')[1];
                PdfFile['NomePdf'] = uuid + '_' + file.name;
                setPdfFile(PdfFile);
            }

            axios
            .post(process.env.REACT_APP_API_URL +
                '/routes.php?metodo=uploadAnexoAssembleia', formData, 
                {
                    headers: 
                    {
                        "X-Access-Token" : tokenAPI,
                        "Content-Type": "multipart/form-data; charset=utf-8"
                    }
                }
            )
            .then(response => {
                assembleia.assAnexo = response.data['filePath'];
                setUploadStatus(`Sucesso: ${response.data.message}`);
                salvarAssembleia();
                setBloqueio(false);
            })
            .catch(error => {
                setUploadStatus(`Erro: ${error.message}`);
                setBloqueio(true);
                return;
            });
        } else {
            setBloqueio(false);
            salvarAssembleia(event);
        }
    }
    //console.log(`Assembleia atual: `, assembleia);
    function salvarAssembleia(event) {
        event.preventDefault();
        if (bloqueio === false) { // This line can remain as is, or you could also use !bloqueio for readability.
            if (assembleia.IdAssembleia > 0) {
                // atualizar assembleia existente
                axios
                .post(process.env.REACT_APP_API_URL +
                    '/routes.php?metodo=alterarAssembleia', assembleia, 
                    {
                        headers: 
                        {
                            "X-Access-Token" : tokenAPI,
                            "Content-Type": "application/json; charset=utf-8"
                        }
                    }
                )
                .then(response => {
                    alert(response.data.message);
                    //console.log(assembleia);
                    if (assembleia.assPosicao && assembleia.assPosicao.toLowerCase() === "convocado" && parseInt(assembleia.assEnviarComunicacao) === 1) {
                        enviarEmailsConvocacao();
                    } else if (assembleia.assPosicao && assembleia.assPosicao.toLowerCase() === "andamento" && parseInt(assembleia.assEnviarComunicacao) === 1) {
                        enviarEmailsAndamento();
                    } else if (assembleia.assPosicao && assembleia.assPosicao.toLowerCase() === "cancelado" && parseInt(assembleia.assEnviarComunicacao) === 1) {
                        enviarEmailsCancelamento();
                    } else if (assembleia.assPosicao && assembleia.assPosicao.toLowerCase() === "encerrado" && parseInt(assembleia.assEnviarComunicacao) === 1) {
                        enviarEmailsEncerramento();
                    }
                    window.history.back();
                })
                .catch(error => {
                    alert(`Houve um erro ao atualizar a assembleia:: ` + error.message);
                });
            } else {
                // criar nova assembleia
                axios
                .post(process.env.REACT_APP_API_URL +
                    '/routes.php?metodo=novaAssembleia', assembleia, 
                    {
                        headers: 
                        {
                            "X-Access-Token" : tokenAPI,
                            "Content-Type": "application/json; charset=utf-8"
                        }
                    }
                )
                .then(response => {
                    alert(`Assembleia criada com sucesso`);
                    //obtem dados da assembleia recém-criada
                    const dados = {
                        assCodigoGUID: assembleia.assCodigoGUID
                    }
                    axios
                    .post(
                        process.env.REACT_APP_API_URL +
                        `/routes.php?metodo=obterAssembleias`,
                        JSON.stringify(dados),
                        { headers: { 
                            "X-Access-Token": tokenAPI,
                            "Content-Type": "application/json; charset=UTF-8"
                        } }
                    )
                    .then(response => {
                        if(response.data) {
                            setAssembleia(response.data[0]);
                            setIsLoading(false);
                        } else {
                            alert('Assembleia não encontrada. Por favor, verifique o ID da assembleia e tente novamente.');
                            setIsLoading(false);
                            return;
                            //navigate('/Assembleias');
                        }
                        
                    })
                    .catch(error => {
                        let ret = error.message;
                        console.log('Erro ao buscar informações da assembleia:', error);
                        alert('Ocorreu um erro ao carregar as informações da assembleia. Por favor, tente novamente mais tarde.');
                        setIsLoading(false);
                        if (ret.includes("401")) {
                            console.log("token inválido!")
                        }
                    });
                    enviarEmailsConvocacao();
                })
                .catch(error => {
                    alert(`Houve um erro ao criar a assembleia: ` + error.message);
                });
            }
        } else {
            window.history.back();
        }

    }
    // Funções para enviar emails de convocação, andamento, cancelamento e encerramento para todos
    function enviarEmailsConvocacao() {
        // console.log(`Assembleia salva, enviar email `, assembleia);
        // return;
        if (parseInt(assembleia.assEnviarComunicacao) === 1 && assembleia.assConvocados != null && assembleia.assConvocados !== '' && assembleia.assConvocados.length > 0){
            if(window.confirm(`Deseja enviar a convocação para os convidados?`)) {
                for (const convidado of pessoasConvocadas) 
                {
                    enviarEmailIndividualConvocacao(convidado);
                }
            }
        }
        window.location.href = '/Assembleias';
    }
    function enviarEmailsAndamento() {
        if (parseInt(assembleia.assEnviarComunicacao) === 1 && assembleia.assConvocados != null && assembleia.assConvocados !== '' && assembleia.assConvocados.length > 0){
            if(window.confirm(`Deseja enviar a comunicação para os convidados?`)) {
                for (const convidado of pessoasConvocadas) {
                    enviarEmailIndividualAndamento(convidado);
                }
            }
        }
    }
    function enviarEmailsCancelamento() {
        if (parseInt(assembleia.assEnviarComunicacao) === 1 && assembleia.assConvocados != null && assembleia.assConvocados !== '' && assembleia.assConvocados.length > 0){
            if(!window.confirm(`Deseja enviar a comunicação de cancelamento para os convidados?`)) {
                return;
            }
            
            for (const convidado of pessoasConvocadas) 
            {
                enviarEmailIndividualCancelamento(convidado);
            }
        }
    }
    function enviarEmailsEncerramento() {
        if (parseInt(assembleia.assEnviarComunicacao) === 1 && assembleia.assConvocados != null && assembleia.assConvocados !== '' && assembleia.assConvocados.length > 0){
            
            if(!window.confirm(`Deseja enviar a comunicação de encerramento para os convidados?`)) {
                return;
            }
            
            let listaPresentes = "";
            for (const presente of pessoasPresentes) {
                listaPresentes += `${presente.pesNome}, `;
            }
            // Remove the trailing comma and space
            listaPresentes = listaPresentes.slice(0, -2);

            for (const convidado of pessoasConvocadas) 
            {
                enviarEmailIndividualEncerramento(convidado, listaPresentes);
            }
        }
    }
    // Funções para enviar emails individuais
    function enviarEmailIndividualConvocacao(convidado) {
        if (!convidado.pesEmail  || convidado.pesEmail.trim() === '') {
            console.log(`O convidado ${convidado.pesNome} não possui um email válido.`);
        } else {
            //formatar a data da assConvocacao para formato br
            const dataFormatada = new Date(assembleia.assConvocacao).toLocaleDateString('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
            var corpoEmail = `
            <div style="margin: 0px; width: 100vw; height: 100vh; color: white; background-color: black; font-family: Arial, Helvetica, sans-serif;">
                <div style="width: 100%; display: flex; justify-content: center; align-items: center; padding-top: 20px;">
                    <img width="200px" src="https://www.brasilextremos.com.br/api/uploads/fotos/logo_mgbe.png" alt="logoMGBE"/>
                </div>
                <div style="width: 100%; display: flex; justify-content: center; align-items: center; padding-top: 20px;">
                    <div style="padding-top:20px;padding-bottom:10px; max-width: 450px;font-weight:bold; font-size:14px; text-align:left;">
                        Caro ${convidado.pesNome}, você está convidado para participação:
                        <br/><br />
                        Convocação: ${assembleia.IdAssembleia}/${new Date(assembleia.assConvocacao).getFullYear()}
                        <br/><br />
                        ${assembleia.assDescricao}
                    </div>
                </div>
                <div style="width: 100%; display: flex; justify-content: center; align-items: center; padding-top: 20px;">
                    <div style="padding-top:20px;padding-bottom:10px; max-width: 450px;font-weight:bold; font-size:14px; text-align:left;">
                        DATA DA ASSEMBLEIA: ${dataFormatada}
                        <br /><br />
                        ${assembleia.assPrimeiraConvocacao ? `HORÁRIO DA ASSEMBLEIA (1ª CHAMADA): ${assembleia.assPrimeiraConvocacao} Hrs`  : ''}<br /><br />
                        ${assembleia.assSegundaConvocacao ? `HORÁRIO DA ASSEMBLEIA (2ª CHAMADA): ${assembleia.assSegundaConvocacao} Hrs` : ''}<br />
                    </div>
                </div>
                <div style="width: 100%; display: flex; justify-content: center; align-items: center; padding-top: 20px;">
                    <div style="padding-top:20px;padding-bottom:10px; max-width: 450px;font-weight:bold; font-size:14px; text-align:left;">
                        ${assembleia.assLocalPresencial ? `LOCAL DA ASSEMBLEIA: ${assembleia.assLocalPresencial}` : ''}<br />
                    </div>
                </div>
                <div style="width: 100%; display: flex; justify-content: center; align-items: center; padding-top: 20px;">
                    <div style="padding-top:20px;padding-bottom:10px; max-width: 450px;font-weight:600; font-size:14px; text-align:left;">
                        ${assembleia.assLinkDeAcesso ? `Link da assembleia: No horário informado: <br/> <a href="${assembleia.assLinkDeAcesso}" target="_blank" style="Text-decoration: none;"> Clique aqui para participar</a>` : ''}
                    </div>
                </div>
                <hr />
                <div style="font-size: 12px; color: #c1bbbb; padding: 10px;">
                    O conteúdo desse e-mail é destinado apenas ao destinatário.<br />
                    Seu conteúdo é classificado como confidencial e não deve ser divulgado, copiado ou distribuído a terceiros sem autorização.<br />
                    A violação de confidencialidade e privacidade com base nas Leis de Proteção de Dados, de Propriedade Intelectual e de Regulação de Uso da Internet pode resultar em responsabilidade civil e criminal.<br />
                    Agradecemos sua compreensão e cooperação.<br />
                    <p> Se você recebeu este e-mail por engano, por favor, notifique o remetente e exclua-o imediatamente.</p>
                </div>
            </div>
            `;
            const dadosEmail = {
                "email": convidado.pesEmail,
                "assunto": `MGBE - Convocação para Assembleia` + `: ${assembleia.assTipo}`,
                "mensagem": corpoEmail
            };
            axios
            .post(process.env.REACT_APP_API_URL + '/routes.php?metodo=enviarEmail', 
                dadosEmail,
                {
                    headers: 
                    {
                        "X-Access-Token" : tokenAPI,
                        "Content-Type": "application/json; charset=utf-8"
                    }
                }
            )
            .then(response => {
                console.log('Resposta do envio de email para ' + convidado.pesEmail + ':', response.data);
                if (response.data.message === 'E-mail enviado com sucesso!') {
                    console.log('Email enviado para ' + convidado.pesEmail);
                } else {
                    console.log('Erro ao enviar email para ' + convidado.pesEmail);
                }
            })
            .catch(error => {
                alert(`Houve um erro ao enviar o email`);
            });
        }
    }

    function enviarEmailIndividualAndamento(convidado) {
        if (!convidado.pesEmail  || convidado.pesEmail.trim() === '') {
            console.log(`O convidado ${convidado.pesNome} não possui um email válido.`);
        } else {
            const dataFormatada = new Date(assembleia.assConvocacao).toLocaleDateString('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
            var corpoEmail = `
                <div style="margin: 0px; width: 100vw; height: 100vh; color: white; background-color: black; font-family: Arial, Helvetica, sans-serif;">
                <div style="width: 100%; display: flex; justify-content: center; align-items: center; padding-top: 20px;">
                    <img width="200px" src="https://www.brasilextremos.com.br/api/uploads/fotos/logo_mgbe.png" alt="logoMGBE"/>
                </div>
                <div style="width: 100%; display: flex; justify-content: center; align-items: center; padding-top: 20px;">
                    <div style="padding-top:20px;padding-bottom:10px; max-width: 450px;font-weight:bold; font-size:14px; text-align:left;">
                        Caro ${convidado.pesNome}, informamos que se encontra em andamento:
                        <br/><br/>
                        Convocação: ${assembleia.IdAssembleia}/${new Date(assembleia.assConvocacao).getFullYear()}
                        <br/><br/>
                        ${assembleia.assDescricao}
                    </div>
                </div>
                <div style="width: 100%; display: flex; justify-content: center; align-items: center; padding-top: 20px;">
                    <div style="padding-top:20px;padding-bottom:10px; max-width: 450px;font-weight:bold; font-size:14px; text-align:left;">
                        DATA DA ASSEMBLEIA: ${dataFormatada}
                        <br /><br />
                        ${assembleia.assPrimeiraConvocacao ? `HORÁRIO DA ASSEMBLEIA (1ª CHAMADA): ${assembleia.assPrimeiraConvocacao} Hrs`  : ''}<br /><br />
                        ${assembleia.assSegundaConvocacao ? `HORÁRIO DA ASSEMBLEIA (2ª CHAMADA): ${assembleia.assSegundaConvocacao} Hrs` : ''}<br />
                    </div>
                </div>
                <div style="width: 100%; display: flex; justify-content: center; align-items: center; padding-top: 20px;">
                    <div style="padding-top:20px;padding-bottom:10px; max-width: 450px;font-weight:bold; font-size:14px; text-align:left;">
                        ${assembleia.assLocalPresencial ? `LOCAL DA ASSEMBLEIA: ${assembleia.assLocalPresencial}` : ''}<br />
                    </div>
                </div>
                <div style="width: 100%; display: flex; justify-content: center; align-items: center; padding-top: 20px;">
                    <div style="padding-top:20px;padding-bottom:10px; max-width: 450px;font-weight:600; font-size:14px; text-align:left;">
                        ${assembleia.assLinkDeAcesso ? `Link da assembleia: <a href="${assembleia.assLinkDeAcesso}" target="_blank" style="Text-decoration: none;"> CLIQUE AQUI PARA PARTICIPAR </a>` : ''}
                    </div>
                </div>
                <hr />
                <div style="font-size: 12px; color: #c1bbbb; padding: 10px;">
                    O conteúdo desse e-mail é destinado apenas ao destinatário.<br />
                    Seu conteúdo é classificado como confidencial e não deve ser divulgado, copiado ou distribuído a terceiros sem autorização.<br />
                    A violação de confidencialidade e privacidade com base nas Leis de Proteção de Dados, de Propriedade Intelectual e de Regulação de Uso da Internet pode resultar em responsabilidade civil e criminal.<br />
                    Agradecemos sua compreensão e cooperação.<br />
                    <p> Se você recebeu este e-mail por engano, por favor, notifique o remetente e exclua-o imediatamente.</p>
                </div>
            </div>
            `;
            const dadosEmail = {
                "email": convidado.pesEmail,
                "assunto": `MGBE - Assembleia em Andamento` + `: ${assembleia.assTipo}`,
                "mensagem": corpoEmail
            };
            axios
            .post(process.env.REACT_APP_API_URL + '/routes.php?metodo=enviarEmail', 
                dadosEmail,
                {
                    headers: 
                    {
                        "X-Access-Token" : tokenAPI,
                        "Content-Type": "application/json; charset=utf-8"
                    }
                }
            )
            .then(response => {
                console.log('Resposta do envio de email para ' + convidado.pesEmail + ':', response.data);
                if (response.data.message === 'E-mail enviado com sucesso!') {
                    console.log('Email enviado para ' + convidado.pesEmail);
                } else {
                    console.log('Erro ao enviar email para ' + convidado.pesEmail);
                }
            })
            .catch(error => {
                alert(`Houve um erro ao enviar o email`);
            });
        }
    }

    function enviarEmailIndividualCancelamento(convidado) {
        if (!convidado.pesEmail  || convidado.pesEmail.trim() === '') {
            console.log(`O convidado ${convidado.pesNome} não possui um email válido.`);
        } else {
            const dataFormatada = new Date(assembleia.assConvocacao).toLocaleDateString('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
            var corpoEmail = `
            <div style="margin: 0px; width: 100vw; height: 100vh; color: white; background-color: black; font-family: Arial, Helvetica, sans-serif;">
                <div style="width: 100%; display: flex; justify-content: center; align-items: center; padding-top: 20px;">
                    <img width="200px" src="https://www.brasilextremos.com.br/api/uploads/fotos/logo_mgbe.png" alt="logoMGBE"/>
                </div>
                <div style="width: 100%; display: flex; justify-content: center; align-items: center; padding-top: 20px;">
                    <div style="padding-top:20px;padding-bottom:10px; max-width: 450px;font-weight:bold; font-size:14px; text-align:left;">
                        Caro ${convidado.pesNome}, informamos o Cancelamento da Assembleia:
                        <br/><br />
                        Convocação: ${assembleia.IdAssembleia}/${new Date(assembleia.assConvocacao).getFullYear()}
                        <br/>
                        <br/>
                        ${assembleia.assDescricao}
                    </div>
                </div>
                <div style="width: 100%; display: flex; justify-content: center; align-items: center; padding-top: 20px;">
                    <div style="padding-top:20px;padding-bottom:10px; max-width: 450px;font-weight:bold; font-size:14px; text-align:left;">
                        DATA DA ASSEMBLEIA: ${dataFormatada}
                        <br /><br />
                        UMA NOVA DATA SERÁ INFORMADA POSTERIORMENTE.
                    </div>
                </div>
                <div style="width: 100%; display: flex; justify-content: center; align-items: center; padding-top: 20px;">
                    <div style="padding-top:20px;padding-bottom:10px; max-width: 450px;font-weight:bold; font-size:14px; text-align:left;">
                        CHEGARÁ AO SEU EMAIL UMA NOVA CONVOCAÇÃO COM A DATA ATUALIZADA.<br />
                    </div>
                </div>
                
                <hr />
                <div style="font-size: 12px; color: #c1bbbb; padding: 10px;">
                    O conteúdo desse e-mail é destinado apenas ao destinatário.<br />
                    Seu conteúdo é classificado como confidencial e não deve ser divulgado, copiado ou distribuído a terceiros sem autorização.<br />
                    A violação de confidencialidade e privacidade com base nas Leis de Proteção de Dados, de Propriedade Intelectual e de Regulação de Uso da Internet pode resultar em responsabilidade civil e criminal.<br />
                    Agradecemos sua compreensão e cooperação.<br />
                    <p> Se você recebeu este e-mail por engano, por favor, notifique o remetente e exclua-o imediatamente.</p>
                </div>
            </div>
            `;
            const dadosEmail = {
                para: convidado.pesEmail,
                assunto: `MGBE - Assembleia Cancelada` + `: ${assembleia.assTipo}`,
                mensagem: corpoEmail
            };
            axios
            .post(process.env.REACT_APP_API_URL + '/routes.php?metodo=enviarEmail', 
                dadosEmail,
                {
                    headers: 
                    {
                        "X-Access-Token" : tokenAPI,
                        "Content-Type": "application/json; charset=utf-8"
                    }
                }
            )
            .then(response => {
                console.log('Resposta do envio de email para ' + convidado.pesEmail + ':', response.data);
                if (response.data.message === 'E-mail enviado com sucesso!') {
                    console.log('Email enviado para ' + convidado.pesEmail);
                } else {
                    console.log('Erro ao enviar email para ' + convidado.pesEmail);
                }
            })
            .catch(error => {
                alert(`Houve um erro ao enviar o email`);
            });
        }
    }

    function enviarEmailIndividualEncerramento(convidado, listaPresentes) {
        if (!listaPresentes || listaPresentes === undefined || listaPresentes === "" || listaPresentes.length === 0) {
            listaPresentes = "";
            for (const presente of pessoasPresentes) {
                listaPresentes += `${presente.pesNome}, `;
            }
            // Remove the trailing comma and space
            listaPresentes = listaPresentes.slice(0, -2);
        }
        //console.log(listaPresentes); return;
        // Lógica para enviar email individual de encerramento
        if (!convidado.pesEmail  || convidado.pesEmail.trim() === '') {
            console.log(`O convidado ${convidado.pesNome} não possui um email válido.`);
        } else {
            //formatar a data da assConvocacao para formato br
            const dataFormatada = new Date(assembleia.assConvocacao).toLocaleDateString('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
            var corpoEmail = `
            <div style="margin: 0px; width: 100vw; height: 100vh; color: white; background-color: black; font-family: Arial, Helvetica, sans-serif;">
                <div style="width: 100%; display: flex; justify-content: center; align-items: center; padding-top: 20px;">
                    <img width="200px" src="https://www.brasilextremos.com.br/api/uploads/fotos/logo_mgbe.png" alt="logoMGBE"/>
                </div>
                <div style="width: 100%; display: flex; justify-content: center; align-items: center; padding-top: 20px;">
                    <div style="padding-top:20px;padding-bottom:10px; max-width: 450px;font-weight:bold; font-size:14px; text-align:left;">
                        Caro ${convidado.pesNome}, você está recebendo o encerramento da Assembleia:
                        <br/><br />
                        Convocação: ${assembleia.IdAssembleia}/${new Date(assembleia.assConvocacao).getFullYear()}
                        <br/>
                        <br/>
                        ${assembleia.assDescricao}
                    </div>
                </div>
                <div style="width: 100%; display: flex; justify-content: center; align-items: center; padding-top: 20px;">
                    <div style="padding-top:20px;padding-bottom:10px; max-width: 450px;font-weight:bold; font-size:14px; text-align:left;">
                        DATA DA ASSEMBLEIA: ${dataFormatada}
                        <br /><br />
                        ATA COM O RESUMO DA ASSEMBLEIA:
                        <br /><br />
                        ${assembleia.assAta}
                    </div>
                </div>
                <div style="width: 100%; display: flex; justify-content: center; align-items: center; padding-top: 20px;">
                    <div style="padding-top:20px;padding-bottom:10px; max-width: 450px;font-weight:bold; font-size:14px; text-align:left;">
                        LISTA DE PRESENTES:
                        <br /><br />
                        ${listaPresentes}
                    </div>
                </div>
                <hr />
                <div style="font-size: 12px; color: #c1bbbb; padding: 10px;">
                    O conteúdo desse e-mail é destinado apenas ao destinatário.<br />
                    Seu conteúdo é classificado como confidencial e não deve ser divulgado, copiado ou distribuído a terceiros sem autorização.<br />
                    A violação de confidencialidade e privacidade com base nas Leis de Proteção de Dados, de Propriedade Intelectual e de Regulação de Uso da Internet pode resultar em responsabilidade civil e criminal.<br />
                    Agradecemos sua compreensão e cooperação.<br />
                    <p> Se você recebeu este e-mail por engano, por favor, notifique o remetente e exclua-o imediatamente.</p>
                </div>
            </div>
            `;
            const dadosEmail = {
                "email": convidado.pesEmail,
                "assunto": `MGBE - Assembleia Encerrada` + `: ${assembleia.assTipo}`,
                "mensagem": corpoEmail
            };
            axios
            .post(process.env.REACT_APP_API_URL + '/routes.php?metodo=enviarEmail', 
                dadosEmail,
                {
                    headers: 
                    {
                        "X-Access-Token" : tokenAPI,
                        "Content-Type": "application/json; charset=utf-8"
                    }
                }
            )
            .then(response => {
                //console.log('Resposta do envio de email para ' + convidado.pesEmail + ':', response.data);
                if (response.data.message === 'E-mail enviado com sucesso!') {
                    console.log('Email enviado para ' + convidado.pesEmail);
                } else {
                    console.log('Erro ao enviar email para ' + convidado.pesEmail);
                }
            })
            .catch(error => {
                alert(`Houve um erro ao enviar o email`);
            });
        }
    }
    
    function enviarEmailIndividual(pessoa) {
        if (window.confirm(`Deseja enviar o email para ${pessoa.pesNome}?`)) {
            if (assembleia.assPosicao === "ENCERRADO") {
                let listaPresentes = "";
                enviarEmailIndividualEncerramento(pessoa, "");
            } else if (assembleia.assPosicao === "CONVOCADO") {
                enviarEmailIndividualConvocacao(pessoa);
            } else if (assembleia.assPosicao === "CANCELADO") {
                enviarEmailIndividualCancelamento(pessoa);
            } else if (assembleia.assPosicao === "ANDAMENTO") {
                enviarEmailIndividualAndamento(pessoa);
            }
        }
    }

    const enviarWhatsAppIndividual = (pessoa) => {
        const nomeFormatado = formatarNome(pessoa.pesNome);
        if (window.confirm(`Deseja enviar a mensagem via WhatsApp para ${nomeFormatado}?`)) {
            enviarWhatsAppSelecionado(pessoa);
        }
    };
    const enviarWhatsAppSelecionado = (pessoa) => {
        try {
            const nomeFormatado = formatarNome(pessoa.pesNome);
            const celularFormatado = `+55${pessoa.pesCelular.replace(' ', '').replace('-', '').replace('(', '').replace(')', '')}`;
            const dataFormatada = new Date(assembleia.assConvocacao).toLocaleDateString('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
            let texto = "";
            if(assembleia.assPosicao === "CONVOCADO"){
                texto = `Olá, ${nomeFormatado}.\n\nVocê está recebendo um convite para participação na assembleia:\nConvocação: ${assembleia.IdAssembleia + '/' + new Date(assembleia.assConvocacao).getFullYear()}. \nData de realização: ${dataFormatada} às ${assembleia.assPrimeiraConvocacao}. \nAssunto: ${assembleia.assDescricao}. \n\nNa data e horário informados, acesse o link da assembleia para participar: \n\n${assembleia.assLinkDeAcesso ? assembleia.assLinkDeAcesso : ''}\n\nGestão MGBE.`;
            } else if(assembleia.assPosicao === "CANCELADO"){
                texto = `Olá, ${nomeFormatado}.\n\nInformamos que a assembleia:\nConvocação: ${assembleia.IdAssembleia + '/' + new Date(assembleia.assConvocacao).getFullYear()}. \nData de realização: ${dataFormatada} às ${assembleia.assPrimeiraConvocacao}. \nAssunto: ${assembleia.assDescricao}. \n\nFOI CANCELADA.\n\nGestão MGBE.`;
            } else if(assembleia.assPosicao === "ENCERRADO"){
                texto = `Olá, ${nomeFormatado}.\n\nInformamos que a assembleia:\nConvocação: ${assembleia.IdAssembleia + '/' + new Date(assembleia.assConvocacao).getFullYear()}. \nData de realização: ${dataFormatada} às ${assembleia.assPrimeiraConvocacao}. \nAssunto: ${assembleia.assDescricao}. \n\nFOI ENCERRADA.\n\nGestão MGBE.`;
            } else if(assembleia.assPosicao === "ANDAMENTO"){
                texto = `Olá, ${nomeFormatado}.\n\nInformamos que a assembleia:\nConvocação: ${assembleia.IdAssembleia + '/' + new Date(assembleia.assConvocacao).getFullYear()}. \nData de realização: ${dataFormatada} às ${assembleia.assPrimeiraConvocacao}. \nAssunto: ${assembleia.assDescricao}. \n\nESTÁ EM ANDAMENTO.\nAcesse o link da assembleia para participar: \n\n${assembleia.assLinkDeAcesso ? assembleia.assLinkDeAcesso : ''}\n\nGestão MGBE.`;
            }
            
            if(texto !== "") {
                //console.log('Enviando mensagem via WhatsApp para ' + pessoa.pesNome + ' no número ' + celularFormatado); return;
                window.open(`https://wa.me/${celularFormatado}?text=${encodeURIComponent(texto)}`, '_blank');
            }
        } catch (error) {
            alert('Erro ao enviar mensagem via WhatsApp para o associado: ' + error.message);
        }
    };
//console.log(assembleia);
    return (
        <div style={{ paddingBottom: '80px' }}>
            <main>
                <div>
                    {/* fechar */}
                    <div className='d-flex w100 mt1 flex-column text-align-left'>
                        <div className='text-align-left w80 fs16'>
                            <button
                                className="buttonModalPadraoLaranja fs11"
                                onClick={handleFecharModal}>Fechar
                            </button>
                        </div>
                    </div>
                    {/* form */}
                    <div>
                        {parseInt(sessionStorage.pesAdmin) === 1 ? (
                            <div>
                                <div className="headerMain">
                                    <label className='labelTitulo fs12' >Detalhes Assembleia</label>
                                </div>
                                <div className="d-flex w100 flex-column tdAlignLeft pb4">
                                    {/* Descricao da assembleia */}
                                    <div className="d-flex flex-row divForm">
                                        <div className="w100">
                                            <div className="text-align-left divForm fs12">
                                                <label>DESCRIÇÃO</label>
                                            </div>
                                            <div className="text-align-left divForm w100 fs12 mt1">
                                                <textarea
                                                    defaultValue={assembleia.assDescricao}
                                                    onChange={(e) => setAssembleia({...assembleia, assDescricao: e.target.value})}
                                                    className="pt1 pb1 p1 fs12 w100 text-align-left"
                                                    required
                                                    maxLength={255}
                                                    name="assDescricao"
                                                    id="assDescricao"
                                                    // ref={textareaRef}
                                                    // onInput={handleInput}
                                                    style={{
                                                    width: '100%',
                                                    padding: '8px',
                                                    }}
                                                />
                                            </div>
                                            {assembleia.assDescricao.length}/255
                                        </div>
                                    </div>
                                    {/* Tipo de Assembleia, select com opções de: ORDINÁRIA, EXTRAORDINÁRIA e GESTÃO */}
                                    <div className="d-flex flex-row divForm">
                                        <div className="w100">
                                            <div className="text-align-left divForm fs12">
                                                <label>TIPO DE ASSEMBLEIA</label>
                                            </div>
                                            <div className="text-align-left divForm w100 fs12 mt1">
                                                <select
                                                    defaultValue={assembleia.assTipo}
                                                    onChange={(e) => setAssembleia({...assembleia, assTipo: e.target.value})}
                                                    className="pt1 pb1 p1 fs12 w100 text-align-left"
                                                    required
                                                    name="assTipo"
                                                    id="assTipo"
                                                >
                                                    <option value="" selected={assembleia.assTipo === ""}>SELECIONE</option>
                                                    <option value="ORDINÁRIA" selected={assembleia.assTipo === "ORDINÁRIA"}>ORDINÁRIA</option>
                                                    <option value="EXTRAORDINÁRIA" selected={assembleia.assTipo === "EXTRAORDINÁRIA"}>EXTRAORDINÁRIA</option>
                                                    <option value="GESTÃO" selected={assembleia.assTipo === "GESTÃO"}>GESTÃO</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Formato da assembleia, select com opções de: VIRTUAL, PRESENCIAL E MISTA */}
                                    {/* assPosicao é um select com opções de: CONVOCAÇÃO, ANDAMENTO, CANCELADO, ENCERRADO */}
                                    <div className="d-flex flex-row divForm">
                                        <div className="w50">
                                            <div className="text-align-left divForm fs12 w100">
                                                <label>FORMATO</label>
                                            </div>
                                            <div className="text-align-left divForm w100 fs12 mt1">
                                                <select
                                                    defaultValue={assembleia.assFormato}
                                                    onChange={(e) => setAssembleia({...assembleia, assFormato: e.target.value})}
                                                    className="pt1 pb1 p1 fs12 w100 text-align-left"
                                                    required
                                                    name="assFormato"
                                                    id="assFormato"
                                                >
                                                    <option value="" selected={assembleia.assFormato === ""}>SELECIONE</option>
                                                    <option value="VIRTUAL" selected={assembleia.assFormato === "VIRTUAL"}>VIRTUAL</option>
                                                    <option value="PRESENCIAL" selected={assembleia.assFormato === "PRESENCIAL"}>PRESENCIAL</option>
                                                    <option value="HÍBRIDA" selected={assembleia.assFormato === "HÍBRIDA"}>HÍBRIDA</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="w50">
                                            <div className="text-align-left divForm fs12 w100">
                                                <label>POSIÇÃO</label>
                                            </div>
                                            <div className="text-align-left divForm w100 fs12 mt1">
                                                <select
                                                    value={assembleia.assPosicao}
                                                    onChange={(e) => setAssembleia({...assembleia, assPosicao: e.target.value})}
                                                    className="pt1 pb1 p1 fs12 w100 text-align-left"
                                                    required
                                                    name="assPosicao"
                                                    id="assPosicao"
                                                >
                                                    <option value="" selected={assembleia.assPosicao === ""}>SELECIONE</option>
                                                    <option value="CONVOCADO" selected={assembleia.assPosicao === "CONVOCADO"}>CONVOCADO</option>
                                                    <option value="ANDAMENTO" selected={assembleia.assPosicao === "ANDAMENTO"}>ANDAMENTO</option>
                                                    <option value="CANCELADO" selected={assembleia.assPosicao === "CANCELADO"}>CANCELADO</option>
                                                    <option value="ENCERRADO" selected={assembleia.assPosicao === "ENCERRADO"}>ENCERRADO</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    {/* assConvocacao é a data para realização da assembleia, exibe como data formato dd/MM/yyyy mas salva como texto */}
                                    <div className="d-flex flex-row divForm">
                                        <div className="w100">
                                            <div className="text-align-left divForm fs12 w100">
                                                <label>DATA DE CONVOCAÇÃO</label>
                                            </div>
                                            <div className="text-align-left divForm w100 fs12 mt1">
                                                <input
                                                    type="date"
                                                    defaultValue={assembleia.assConvocacao}
                                                    onChange={(e) => setAssembleia({...assembleia, assConvocacao: e.target.value})}
                                                    className="pt1 pb1 p1 fs12 w100 text-align-left"
                                                    required
                                                    name="assConvocacao"
                                                    id="assConvocacao"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {/* assPrimeiraConvocacao é a hora da primeira convocação com formato HH:mm e ao lado assSegundaConvocacao é a hora da segunda convocação */}
                                    <div className="d-flex flex-row divForm">
                                        <div className="w50">
                                            <div className="text-align-left divForm fs12 w100">
                                                <label>1º CHAMADA</label>
                                            </div>
                                            <div className="text-align-left divForm w100 fs12 mt1">
                                                <input
                                                    type="time"
                                                    defaultValue={assembleia.assPrimeiraConvocacao}
                                                    onChange={(e) => setAssembleia({...assembleia, assPrimeiraConvocacao: e.target.value})}
                                                    className="pt1 pb1 p1 fs12 w100 text-align-left"
                                                    required
                                                    name="assPrimeiraConvocacao"
                                                    id="assPrimeiraConvocacao"
                                                />
                                            </div>
                                        </div>
                                        <div className="w50">
                                            <div className="text-align-left divForm fs12 w100">
                                                <label>2º CHAMADA</label>
                                            </div>
                                            <div className="text-align-left divForm w100 fs12 mt1">
                                                <input
                                                    type="time"
                                                    defaultValue={assembleia.assSegundaConvocacao}
                                                    onChange={(e) => setAssembleia({...assembleia, assSegundaConvocacao: e.target.value})}
                                                    className="pt1 pb1 p1 fs12 w100 text-align-left"
                                                    required
                                                    name="assSegundaConvocacao"
                                                    id="assSegundaConvocacao"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {/* assLocalPresencial, caso seja presencial, é o local onde a assembleia será realizada */}
                                    <div className="d-flex flex-row divForm">
                                        <div className="w100">
                                            <div className="text-align-left divForm fs12 w100">
                                                <label>LOCAL PRESENCIAL</label>
                                            </div>
                                            <div className="text-align-left divForm w100 fs12 mt1">
                                                <input
                                                    type="text"
                                                    defaultValue={assembleia.assLocalPresencial}
                                                    onChange={(e) => setAssembleia({...assembleia, assLocalPresencial: e.target.value})}
                                                    className="pt1 pb1 p1 fs12 w100 text-align-left"
                                                    required={assembleia.assPresencial || assembleia.assPresencial === 'PRESENCIAL' || assembleia.assPresencial === 'HÍBRIDA'}
                                                    name="assLocalPresencial"
                                                    id="assLocalPresencial"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {/* assLinkDeAcesso, obrigatório caso a assembleia seja online ou híbrida */}
                                    <div className="d-flex flex-row divForm">
                                        <div className="w100">
                                            <div className="text-align-left divForm fs12 w100">
                                                <label>LINK DE ACESSO</label>
                                            </div>
                                            <div className="text-align-left divForm w100 fs12 mt1">
                                                <input
                                                    type="text"
                                                    defaultValue={assembleia.assLinkDeAcesso}
                                                    onChange={(e) => setAssembleia({...assembleia, assLinkDeAcesso: e.target.value})}
                                                    className="pt1 pb1 p1 fs12 w100 text-align-left"
                                                    required={assembleia.assPresencial === 'ONLINE' || assembleia.assPresencial === 'HÍBRIDA'}
                                                    name="assLinkDeAcesso"
                                                    id="assLinkDeAcesso"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {/* assATA é um local para ser escrito a ata, um textbox como o assDescricao para ser adicionado relatos da ata com tamanho máximo de 10000 caracteres */}
                                    <div className="d-flex flex-row divForm">
                                        <div className="w100">
                                            <div className="text-align-left divForm fs12 w100">
                                                <label>REGISTRO DE ATA</label>
                                            </div>
                                            <div className="text-align-left divForm w100 fs12 mt1">
                                                <textarea
                                                    defaultValue={assembleia.assAta}
                                                    onChange={(e) => setAssembleia({...assembleia, assAta: e.target.value})}
                                                    className="pt1 pb1 p1 fs12 w100 text-align-left"
                                                    maxLength={10000}
                                                    required
                                                    name="assAta"
                                                    id="assAta"
                                                    //ref={textareaRef}
                                                    //onInput={handleInput}
                                                    style={{
                                                    width: '100%',
                                                    padding: '8px',
                                                    }}
                                                />
                                            </div>
                                            {assembleia.assAta ? assembleia.assAta.length : 0}/10000
                                        </div>
                                    </div>
                                    {/* assAnexo, local para fazer upload de anexos relacionados à assembleia */}
                                    <div className="d-flex flex-row divForm">
                                        <div className="w100">
                                            <div className="text-align-left divForm fs12 w100">
                                                <label>ANEXAR DOCUMENTO</label>
                                            </div>
                                            <div className="text-align-left divForm w100 fs12 mt1">
                                                <input
                                                    type="file"
                                                    onChange={handleFileChange}
                                                    accept=".pdf"
                                                    className="pt1 pb1 p1 fs12 w100 text-align-left"
                                                    name="assAnexo"
                                                    id="assAnexo"
                                                />
                                            </div>
                                            <div className='text-align-left divForm w100 fs10'>
                                                <label>{assembleia.assAnexo ? assembleia.assAnexo.replace('uploads/assembleias/','') : ''}</label>
                                            </div>
                                        </div>
                                    </div>
                                    {/* assEnviarComunicacao éum select com opções de SIM e NÃO, mas salva no registro como 1 ou 0 */}
                                    {/* assStatus é um select apenas com opções ATIVO e INATIVO, mas salva como 1 ou 0 */}
                                    <div className="d-flex flex-row divForm">
                                        {/* assEnviarComunicacao */}
                                        <div className="w50">
                                            <div className="w100">
                                                <div className="text-align-left divForm fs12 w100">
                                                    <label>COMUNICAR</label>
                                                </div>
                                                <div className="text-align-left divForm w100 fs12 mt1">
                                                    <select
                                                        onChange={(e) => setAssembleia({...assembleia, assEnviarComunicacao: e.target.value})}
                                                        className="pt1 pb1 p1 fs12 w100 text-align-left"
                                                        name="assEnviarComunicacao"
                                                        id="assEnviarComunicacao"
                                                        value={assembleia.assEnviarComunicacao}
                                                    >
                                                        <option value="">Selecione</option>
                                                        <option value="1" selected={assembleia.assEnviarComunicacao === '1'}>SIM</option>
                                                        <option value="0" selected={assembleia.assEnviarComunicacao === '0'}>NÃO</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        {/* assStatus */}
                                        <div className="w50">
                                            <div className="w100">
                                                <div className="text-align-left divForm fs12 w100">
                                                    <label>STATUS</label>
                                                </div>
                                                <div className="text-align-left divForm w100 fs12 mt1">
                                                    <select
                                                        onChange={(e) => setAssembleia({...assembleia, assStatus: e.target.value})}
                                                        className="pt1 pb1 p1 fs12 w100 text-align-left"
                                                        name="assStatus"
                                                        id="assStatus"
                                                        value={assembleia.assStatus}
                                                    >
                                                        <option value="1" selected={assembleia.assStatus === '1'}>ATIVO</option>
                                                        <option value="0" selected={assembleia.assStatus === '0'}>INATIVO</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Convocados e presentes */}
                                    <div className="d-flex flex-row mt2 text-align-center">
                                        <div className="text-align-left divForm fs12 w100 text-align-center">
                                            <label><b>CONVOCADOS & PRESENTES</b></label>
                                        </div>
                                    </div>
                                    <hr className="w100" />
                                    <div className="d-flex flex-row divForm">
                                        {/* Pessoas Convocadas */}
                                        <div className="w50 d-flex" style={{ verticalAlign: 'top', alignSelf: 'flex-start', alignItems: 'flex-start' }}>
                                            {/* lista das pessoas com sinalização de convocados */}
                                            <div className="w100">
                                                <div className="text-align-center divForm fs10 w100">
                                                    <label>CONVOCADOS</label>
                                                </div>
                                                <div className="text-align-center divForm fs12 w100">
                                                {pessoasConvocadas && pessoasConvocadas.filter(pessoa => {
                                                    if(parseInt(pessoa.pesStatus) === 1 && parseInt(pessoa.pesAssociado) === 1){
                                                        return pessoa;
                                                    }
                                                }).length}
                                                </div>
                                                {/* botão para selecionar todos da lista de pessoas */}
                                                <div className="text-align-center mt1">
                                                    <button
                                                        onClick={toggleSelecionarTodos}
                                                        style={{
                                                        padding: '10px 20px',
                                                        marginBottom: '15px',
                                                        cursor: 'pointer',
                                                        backgroundColor: todasSelecionadas ? '#ffcdd2' : '#c8e6c9',
                                                        border: '1px solid #999',
                                                        borderRadius: '4px',
                                                        fontWeight: 'bold'
                                                        }}
                                                        >
                                                        {todasSelecionadas ? 'DESMARCAR TODOS' : 'CONVIDAR TODOS'}
                                                    </button>
                                                </div>
                                                <div className="d-flex flex-column divForm w100 fs09" style={{ backgroundColor: '#979292', padding: '5px' }}>
                                                    {pessoas ?
                                                        pessoas
                                                    .filter(pessoa => {
                                                        if(parseInt(pessoa.pesStatus) === 1 && parseInt(pessoa.pesAssociado) === 1){
                                                            return pessoa;
                                                        }
                                                    })
                                                    .map(pessoa => {
                                                        const estaConvocado = pessoasConvocadas.some((p) => p.IdPessoa === pessoa.IdPessoa);
                                                        return (
                                                            <div key={pessoa.IdPessoa}
                                                                style={{ cursor: 'pointer', width: '100%', borderRadius: '5px', padding: '5px', backgroundColor: estaConvocado ? '#507455' : '#5c5a5a' }} >
                                                                <div
                                                                    onClick={() => toggleConvocaPessoa(pessoa)} 
                                                                    style={{ padding: '3px', textAlign: 'left', paddingTop: '5px' }}>
                                                                    <b>{pessoa.pesNome}</b> 
                                                                    {pessoa.pesEmail ? (
                                                                        <>
                                                                            <br /><span style={{ fontStyle: 'italic', fontSize: '0.8em' }}>{pessoa.pesEmail.split('@')[0]}</span>
                                                                            <br /><span style={{ fontStyle: 'italic', fontSize: '0.7em' }}>@{pessoa.pesEmail.split('@')[1]}</span>
                                                                        </>
                                                                    ) : ''}
                                                                </div>
                                                                <div style={{ display: !estaConvocado ? 'none' : 'block', width: '97%', textAlign: 'center', borderRadius: '5px', paddingBottom: '5px', backgroundColor: '#f2eded', margin: '10px ', padding: '5px' }}>
                                                                    {pessoa.pesEmail && (
                                                                        <Tooltip title="Enviar email de convocação">
                                                                            <label style={{ cursor: 'pointer', marginRight: '15px' }}>
                                                                                <MailOutline style={{ color: '#a3a7e6', fontSize: '30px' }} onClick={() => enviarEmailIndividual(pessoa)} />
                                                                            </label>
                                                                        </Tooltip>
                                                                    )}
                                                                    {pessoa.pesCelular && (
                                                                        <Tooltip title="Enviar mensagem via WhatsApp">
                                                                            <label style={{ cursor: 'pointer', marginRight: '15px' }}>
                                                                                <WhatsApp style={{ color: '#25D366', fontSize: '30px', }} onClick={() => enviarWhatsAppIndividual(pessoa)} />
                                                                            </label>
                                                                        </Tooltip>
                                                                    )}
                                                                </div>
                                                                <div style={{ width: '100%', textAlign: 'right', paddingBottom: '5px' }}>
                                                                    {estaConvocado && <span> (Convocado)</span>}
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                    : <div>Nenhum convocado encontrado.</div>
                                                }
                                                </div>
                                            </div>
                                        </div>
                                        {/* Pessoas Presentes */}
                                        <div className="w50 d-flex" style={{ verticalAlign: 'top', alignSelf: 'flex-start', alignItems: 'flex-start' }}>
                                            {/* lista das pessoas com sinalização de presença */}
                                            <div className="w100">
                                                <div className="text-align-center divForm fs10 w100">
                                                    <label>PRESENTES</label>
                                                </div>
                                                <div className="text-align-center divForm fs12 w100">
                                                {pessoasPresentes && pessoasPresentes.filter(pessoa => {
                                                    if(parseInt(pessoa.pesStatus) === 1 && parseInt(pessoa.pesAssociado) === 1){
                                                        return pessoa;
                                                    }
                                                }).length}
                                                </div>
                                                {/* botão para marcar presença para todos da lista */}
                                                <div className="text-align-center mt1">
                                                    <button
                                                        onClick={toggleMarcarTodosPresentes}
                                                        style={{
                                                        padding: '10px 20px',
                                                        marginBottom: '15px',
                                                        cursor: 'pointer',
                                                        backgroundColor: todasPresentes ? '#ffcdd2' : '#c8e6c9',
                                                        border: '1px solid #999',
                                                        borderRadius: '4px',
                                                        fontWeight: 'bold'
                                                        }}
                                                        >
                                                        {todasPresentes ? 'DESMARCAR TODOS' : 'TODOS PRESENTES'}
                                                    </button>
                                                </div>
                                                <div className="d-flex flex-column divForm w100 fs09" style={{ backgroundColor: '#979292', padding: '5px' }}>
                                                    {pessoasConvocadas ?
                                                        pessoasConvocadas
                                                        .filter(pessoa => {
                                                            if(parseInt(pessoa.pesStatus) === 1 && parseInt(pessoa.pesAssociado) === 1){
                                                                return pessoa;
                                                            }
                                                        })
                                                        .map(pessoa => {
                                                            const estavaPresente = pessoasPresentes.some((p) => p.IdPessoa === pessoa.IdPessoa);
                                                            return (
                                                                <div key={pessoa.IdPessoa}
                                                                    onClick={() => togglePresencaPessoa(pessoa)}
                                                                    style={{ cursor: 'pointer', borderRadius: '5px', padding: '5px', width: '100%', color: estavaPresente ? 'green' : 'red', backgroundColor: estavaPresente ? '#c8e6c9' : '#ffcdd2' }}>
                                                                    <div style={{ padding: '3px', textAlign: 'left', paddingTop: '5px' }}>
                                                                        <b>{pessoa.pesNome}</b> 
                                                                        {pessoa.pesEmail ? (
                                                                        <>
                                                                            <br /><span style={{ fontStyle: 'italic', fontSize: '0.8em' }}>{pessoa.pesEmail.split('@')[0]}</span>
                                                                            <br /><span style={{ fontStyle: 'italic', fontSize: '0.7em' }}>@{pessoa.pesEmail.split('@')[1]}</span>
                                                                        </>
                                                                    ) : ''}
                                                                    </div>
                                                                    <div style={{ width: '100%', textAlign: 'right', paddingBottom: '5px' }}>
                                                                        ({estavaPresente ? 'Presente' : 'Ausente'})
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    : null}
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                    {/* botão de salvar */}
                                    <div className="d-flex flex-row mt2 w100 text-align-center">
                                        {parseInt(sessionStorage.pesAdmin) === 1 
                                             ? (
                                            <div className='text-align-left mt2 mb2 divForm fs12'>
                                                <button onClick={(event) => handleSalvarAssembleia(event)}
                                                className='buttonModalPadrao pt1 pb1 w100 fs12'
                                                type="submit">
                                                    SALVAR ASSEMBLEIA
                                                </button>
                                            </div> ) : ('')}
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <>
                                <div className="headerMain">
                                    <label className='labelTitulo fs12' >Detalhes Assembleia</label>
                                </div>
                            </>
                        )
                        }
                    </div>
                </div>
            </main>
        </div>
    );
}

export default Assembleia;